import { RouteType } from "types/RouteType";
import settingsRoute from "./settings.Route";

const settingsRoutesList: RouteType[] = [
    ...settingsRoute,
];

export default settingsRoutesList;
